"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var orderTagApi = _interopRequireWildcard(require("@/api/orderTagApi.js"));
var _validate = require("@/utils/validate");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      loading: false,
      visible: false,
      details: {},
      // 预留一份数据
      orderNo: '',
      tagOption: [{
        value: 1,
        name: '标签一'
      }, {
        value: 2,
        name: '标签二'
      }],
      checkboxGroup: null,
      pram: {},
      initloading: false
    };
  },
  props: {
    bindType: {
      // 打标类型 0: 订单列表打标 1: 三方订单打标
      type: [Number, String],
      default: 0
    }
  },
  mounted: function mounted() {
    this.pram = {};
  },
  methods: {
    openInit: function openInit(orderNo) {
      this.orderNo = orderNo;
      this.pram = {};
      this.getAllTags(orderNo);
    },
    handerSubmit: (0, _validate.Debounce)(function () {
      var _this = this;
      this.loading = true;
      var _this$pram = this.pram,
        tagId = _this$pram.tagId,
        tagRemark = _this$pram.tagRemark;
      orderTagApi[this.bindType == 1 ? 'addVirtualTag' : 'orderBindTag']({
        orderNo: this.orderNo,
        tagId: tagId,
        tagRemark: tagRemark
      }).then(function (data) {
        _this.$message.success('操作成功');
        _this.loading = false;
        _this.visible = false;
        _this.$emit('doRefresh');
      }).catch(function () {
        _this.loading = false;
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    getAllTags: function getAllTags(orderNo) {
      var _this2 = this;
      this.visible = true;
      this.initloading = true;
      this.tagOption = [];
      orderTagApi[this.bindType == 1 ? 'bindThirdTagDetails' : 'bindTagDetails'](orderNo).then(function (res) {
        var _ref = res || {},
          _ref$tagList = _ref.tagList,
          tagList = _ref$tagList === void 0 ? [] : _ref$tagList,
          tagRemark = _ref.tagRemark;
        var idx = tagList.findIndex(function (tagItem) {
          return tagItem.isChecked;
        });
        _this2.pram = {
          tagId: idx != -1 ? tagList[idx].tagId : null,
          tagRemark: tagRemark
        };
        _this2.tagOption = tagList || [];
        _this2.initloading = false;
      }).catch(function (err) {
        _this2.initloading = false;
      });
    }
  }
};